import React from 'react';
import ComparisonRealPrice from './ComparisonRealPrice';
import VBLoadingScreen from "@vb-js-commons/vbLoadingScreen";
import ComparisonFilter from './ComparisonFilter';
import { getGroupedLineData, getUserRights, getDistrubution, getPulp, getTimber, getBuyer, getPrice } from './api/index';
import { Button, Icon, Text } from "@ui-component-library";
import { TailwindWrapper } from "@utils/TailwindWrapper";
import styled from 'styled-components';
import HourPricesGraphSection from './HourPricesGraphSection'
import GuldAnnons from './GuldAnnons';
import externalTooltipHandler from './config';
import BarGraphSection from './BarGraphSection';
import Cookies from 'js-cookie';
import Modal from 'react-bootstrap/Modal';
import Navigation from '../static/Navigation';
import Footer from '../static/Footer';

const dummybarData = [
  {
    "id": "Dummy data 1",
    "Massaved Prima": 200,
    "Massaved Sekunda": 300,
    "Bränsleved": 140
  },
  {
    "id": "Dummy data 2",
    "Massaved Prima": 250,
    "Massaved Sekunda": 200,
    "Bränsleved": 50
  },
  {
    "id": "Dummy data 3",
    "Massaved Prima": 150,
    "Massaved Sekunda": 220,
    "Bränsleved": 320
  },
  {
    "id": "Dummy data 4",
    "Massaved Prima": 280,
    "Massaved Sekunda": 200,
    "Bränsleved": 100
  }

]
const ContainerRoot = styled.div`
  background-color: white;
  @media (min-width: 992px) {
   }
`
const PlusIcon = styled.span`
  display: inline-block;
  margin-right: 25px;
  font-size: 1.2em;
  cursor: pointer;
  transition: transform 0.2s ease-in-out;
  user-select: none; /* Prevent text selection */

  &::after {
    content: '+';
    display: inline-block;
    line-height: 0.8em;
    transform: rotate(0deg);
    transition: 300ms;
    ${({ isOpen }) => (isOpen && `transform:rotate(360deg)`)}
  }

`;


const AccordionItem = styled.div`
  border-bottom: ${({ isLastItem }) => (isLastItem ? 'none' : '1px solid #D9D7D4')};
  padding: 32px;
  background-color:"#F3F0EC";
  &.open {
    border-bottom-color: transparent;
  }
`;

const QuestionHeading = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;
`;

const AccordionBody = styled.div`
  margin-left: 17px;
  margin-top: 10px;
  padding: 0 20px;
`;

class PriceComparison extends React.Component {
  
  constructor(props) {
    super(props);
    this.data_years = Array.from(new Set(Window.react_data.data.priceIndicatorData[0].data.map(d => { return d.x.slice(-4) }))).map((year, index) => { return { 'value': index + 1, 'label': year } })
    this.data_latest_year = this.data_years[this.data_years.length - 1]['label']
    this.state = {
      playVideo: false,
      pulp_graph_data: [],
      line_graph_data: { "1": [], "2": [], "3": [], "4": [] },
      distributions_data: [],
      store_price_indicator_data: getGroupedLineData(Window.react_data.data.priceIndicatorData, this.data_latest_year),
      real_price_data: null,
      hasSearched: false,
      hasPremium: Window.react_data.isPremium,
      buyer_count: null,
      tree_lbl: "",
      muni_lbl: "",
      hide_popup: false,
      loading: false,
      show_popup: false,
      distrubutionError: '',
      pulpError: '',
      timberError: '',
      priceError: '',
      buyerError: '',
      openItems: [],
      messageSentModal:false,
      isLogged: Window.user_data.isLogged,
    }
  }
  priceIndicatorChangeYear(selected) {
    this.setState({ store_price_indicator_data: getGroupedLineData(Window.react_data.data.priceIndicatorData, selected.label || this.data_latest_year) })
  }


  handleFilterClick(tree, muni, tree_lbl, muni_lbl) {
    fbq('track', 'clicked did pricecomparison');
    gtag('event', 'clicked did pricecomparison', {});
    window.location.hash = "";
    this.setState({
      hasSearched: true,
      loading: true,
      tree_lbl: tree_lbl,
      muni_lbl: muni_lbl,
    });
    let distPrms = getDistrubution(tree, muni).then(resp => {
      if (resp.ok) {
        return { "prms": resp.json(), "name": "pulp_graph_data" }
      } else {
        return { "error": 'Distribution percentages', "name": "distrubutionError" }
      }
    })
    let pulp_prms = getPulp(tree, muni).then(resp => {
      if (resp.ok) {
        return { "prms": resp.json(), "name": "pulp_graph_data" }
      } else {
        return { "error": 'Mass conference prices', "name": "pulpError" }
      }
    })
    let timber_prms = getTimber(tree, muni).then(resp => {
      if (resp.ok) {
        return { "prms": resp.json(), "name": "line_graph_data" }
      } else {
        return { "error": 'Sawing time', "name": "timberError" }
      }
    })
    let price_prms = getPrice(tree, muni).then(resp => {
      if (resp.ok) {
        return { "prms": resp.json(), "name": "real_price_data" }
      } else {
        return { "error": 'Real timber prices', "name": "priceError" }
      }
    })
    let buyer_prms = getBuyer(muni).then(resp => {
      if (resp.ok) {
        return { "prms": resp.json(), "name": "buyer_count" }
      } else {
        return { "error": 'Buyer companies', "name": "buyerError" }
      }
    })

    Promise.all([distPrms, pulp_prms, timber_prms, price_prms, buyer_prms]).then((json_list) => {
      let state_update = {}
      let json_prms = []
      json_list.forEach((data_json) => {
        if (data_json.hasOwnProperty("error")) {
          state_update[data_json["name"]] = data_json["error"]
        } else {
          json_prms.push(data_json["prms"]);
          data_json["prms"].then((json) => {
            state_update[data_json["name"]] = json;
          })
        }
      });
      Promise.all(json_prms).then(() => {
        state_update["loading"] = false;
        this.setState(state_update);
      });
    });
  }

  hasTimberdata(optional) {
    if (optional === undefined) {
      return (this.state.line_graph_data["1"].length > 0 || this.state.line_graph_data["2"].length > 0 || this.state.line_graph_data["3"].length > 0 || this.state.line_graph_data["4"].length > 0)
    } else {
      return (optional["1"].length > 0 || optional["2"].length > 0 || optional["3"].length > 0 || optional["4"].length > 0)
    }
  }

  scrollToSection(section) {
    let premium_required = [
      "pulp",
      "distributions",
      "indicator"
    ]

    if (premium_required.indexOf(section) != -1 && !this.state.hasPremium) {
      window.location.href = "/price-comparison/premium";
      return;
    }

    if (screen.width >= 1200 || section == "premium") {
      $([document.documentElement, document.body]).animate({
        scrollTop: $("#" + section).offset().top - 100
      }, 500);
    } else {
      $("#" + section).addClass("display-mobile");
      window.location.hash = section;
    }

  }

  componentDidMount() {
    window.location.hash = "";
    window.addEventListener("hashchange", this.handleBackClick, false);
    this.setState({
      openItems: Array(4).fill(false),
  });
  }


  handleBackClick() {
    if (window.location.hash == "") {
      if ($(".display-mobile").length > 0) {
        $(".display-mobile").removeClass("display-mobile");
        return false;
      }
    }
  }

  hide(id) {
    window.location.hash = "";
    $(id).removeClass("display-mobile");
  }

  contactUs() {
    if (this.state.isLogged) {
      const headers = {
        'Content-Type': 'application/json',
        'X-CSRFToken': Cookies.get('csrftoken')
      }
      let data = {
        "message": "Användaren begärde att bli kontaktad angående virkespriser.",
      }
      fetch("/create-hubspot-ticket/", {
        method: 'POST',
        headers: headers,
        body: JSON.stringify({ "data": data })
      }).then(res => res.json()).then(json => {
        if (json.ok){
          this.setState({ messageSentModal: true, })
        }
        else{
          console.error(json)
        }    
      });
    }
    else {
      const event = new CustomEvent('openLoginModal', {
        detail: {
          nextUrl: "/virkespriser/"
        }
      });
      window.dispatchEvent(event)
    }
  }
  

  // Rendered sections
  headerSection() {
    return <div className='bg-supp-forest-green'>
      <div className='container'>
        <div className='row py-3 py-md-5'>
          <div className='col-12 col-md-6 order-2 order-md-1 pe-md-4 mt-5 mt-md-0'>
            <div className='mb-4'>
              <h1 className='n-fs-3 n-lg-h3 mb-3 primary-core'>Virkespriser - få rätt pris för din skog</h1>
              <p className='white fw-lighter'>Att få rätt betalt för virket gör stor skillnad för dig som skogsägare. Med Treebulas virkesprisjämförelse får du snabbt och enkelt en tydlig och aktuell bild av virkespriserna i din kommun – helt kostnadsfritt och utan några förbindelser.</p>
            </div>
            <div className='bg-supp-forest-green-700 p-4 rounded-3'>
              <p className='primary-core mb-4'>Jämför ditt pris</p>
              <VBLoadingScreen show_loading={this.state.loading} />
              <ComparisonFilter
                updateNavigation={() => this.navigation.current.updateNavbar()}
                onFilter={this.handleFilterClick.bind(this)}
                hasPremium={this.state.hasPremium}
                show_loading={(loading) => { this.setState({ "loading": loading }) }}
              />

            </div>
          </div>
          <div className='col-12 col-md-6 order-1 order-md-2 ps-md-4 d-flex align-items-stretch'>
            <img src={Window.static_path + 'img/other/lumber-pile.jpg'} className='rounded-4 h-100 img-fluid' style={{ objectFit: 'cover' }} />
          </div>
        </div>
      </div>
    </div>
  }

  graphSection() {
    const non_premium_member = !this.state.hasPremium && this.state.hasSearched;
    const premium_member = this.state.hasSearched || this.state.hasPremium;

    if (non_premium_member) {
      setTimeout(() => {
        let popup_cookie = Cookies.get("price_comp_popup");

        if (!popup_cookie) {
          Cookies.set("price_comp_popup", "1", { expires: 1 });
        }
      }, 10000);
    }

    //tooltip code goes here
    const lineData = this.state.line_graph_data;
    const hourPricesTooltipLine = {
      id: 'hourPriceTooltipLine',
      beforeDraw: chart => {
        if (chart.tooltip?._active && chart.tooltip?._active.length) {
          const ctx = chart.ctx;
          ctx.save();
          const activePoint = chart.tooltip._active[0];

          ctx.beginPath();
          ctx.setLineDash([5, 7]);
          ctx.moveTo(activePoint.element.x, chart.chartArea.top);
          ctx.lineTo(activePoint.element.x, chart.chartArea.bottom);
          ctx.lineWidth = 2;
          ctx.strokeStyle = 'grey';
          ctx.stroke();
          ctx.restore();

        }
      }
    }

    //hourpricedata
    function getHourPriceData(quality) {
      let dataLabels = lineData[quality].map(item => item.data.map(item => item.x)); //["12", "13, "14, ]
      const colors = ["#6A58C6", "#2FAF9A", "#F26157", "#232347", "#023436", "#4C2B36", "#DFFF5D", "#012526", "#217C6D", "#3C416D", "#A84343", "#4C2B36"];
      const exampleData = lineData[quality].map(item => {
        return {
          label: item.id,
          x: item.data.map(item => item.x),
          y: item.data.map(item => item.y),
        }
      })
      return {
        data: {
          quality: quality,
          labels: dataLabels[0],
          datasets: exampleData.map((item, index) => {
            return {
              label: item.label,
              fill: false,
              lineTension: 0.1,
              backgroundColor: colors[index],
              borderColor: colors[index],
              borderCapStyle: 'butt',
              borderDash: [],
              borderDashOffset: 0.0,
              borderJoinStyle: 'miter',
              pointRadius: 2,
              pointBorderColor: colors[index],
              pointBackgroundColor: '#fff',
              pointBorderWidth: 1,
              pointHoverRadius: 2,
              pointHoverBackgroundColor: colors[index],
              pointHoverBorderColor: colors[index],
              pointHoverBorderWidth: 2,
              pointRadius: 2,
              pointHitRadius: 10,
              data: item.y
            }
          })
        },
      }
    }
    const hourPriceAllDataProps = [getHourPriceData("1"), getHourPriceData("2"), getHourPriceData("3"), getHourPriceData("4")];
    const hourPricesOptions = {
      responsive: true,
      plugins: {
        legend: {
          display: true,
          position: screen.width >= 1200 ? 'bottom' : 'bottom',
          align: screen.width >= 1200 ? 'center' : 'start',
          labels: {
            font: {
              size: screen.width >= 1200 ? '16' : '16',
              weight: 400,
              lineHeight: 50,
            }
          }
        },

        interaction: {
          intersect: false,
          mode: 'index',
        },
        tooltip: {
          enabled: true,
          position: 'nearest',
          displayColors: false,
          titleAlign: 'center',
          bodyAlign: "center",
        },
        datalabels: {
          color: 'transparent'
        },
      },
      scales: {
        x: {
          title: {
            display: true,
            text: 'Diameter (cm)',
            font: {
              size: 18,
              weight: 500,
            },
          },
          grid: {
            drawBorder: false,
            display: false,
          },
          ticks: {
            font: {
              size: 18,
              weight: 500,
            },
            color: '#2A2E33',
          },
        },
        y: {
          ticks: {
            font: {
              size: 18,
              weight: 500,
            },
            color: '#2A2E33',
            beginAtZero: false,
            min: 200,
            max: 800,
            stepSize: 100,
            grace: "0.5%",
          },
          grid: {
            drawBorder: false,
            display: false,
          },
        },
      },
      maintainAspectRatio: false,
    }

    /*  price indicator data  */
    let pricelabels = this.state.store_price_indicator_data.map(item => item.id); //labels
    let priceYear = this.state.store_price_indicator_data.map(item => item.data)
    let priceData = this.state.store_price_indicator_data.map(item => item.data)

    function average(ctx) {
      const values = ctx.chart.data.datasets[1].data;
      return values.reduce((a, b) => a + b, 0) / values.length;
    }

    const priceIndicatorGraphData = {
      labels: priceYear[0].map(item => item.x.charAt(0).toUpperCase() + item.x.slice(1).toLowerCase()),
      datasets: [
        {
          label: pricelabels[0],
          fill: false,
          lineTension: 0.1,
          backgroundColor: '#F26157',
          borderWidth: 4,
          borderColor: '#F26157',
          borderCapStyle: 'butt',
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: 'miter',
          pointBorderColor: '#F26157',
          pointBackgroundColor: '#fff',
          pointBorderWidth: 5,
          pointRadius: 0,
          pointHitRadius: 10,
          pointHoverRadius: 8,
          pointHoverBackgroundColor: '#fff',
          pointHoverBorderColor: '#F26157',
          pointHoverBorderWidth: 5,
          data: priceData[0].map(item => item.y)
        },
        {
          label: pricelabels[1],
          fill: false,
          lineTension: 0.1,
          backgroundColor: '#2FAF9A',
          borderWidth: 4,
          borderColor: '#2FAF9A',
          borderCapStyle: 'butt',
          borderDash: [],
          borderDashOffset: 0.0,
          borderJoinStyle: 'miter',
          pointRadius: 0,
          pointHitRadius: 0,
          pointBorderColor: '#2FAF9A',
          pointBackgroundColor: '#fff',
          pointBorderWidth: 0,
          pointHoverRadius: 0,
          pointHoverBackgroundColor: '#fff',
          pointHoverBorderColor: '#2FAF9A',
          pointHoverBorderWidth: 0,
          data: priceData[1].map(item => item.y)
        }
      ]
    }

    const priceIndicatorOptions = {
      responsive: true,
      interaction: {
        intersect: false,
        mode: 'index',
      },
      events: ['mousemove', 'mouseout', 'click', 'touchstart', 'touchmove'],
      plugins: {
        legend: {
          display: false,
        },
        tooltip: {
          enabled: false,
          position: 'nearest',
          external: !this.state.hasPremium && this.state.hasSearched ? null : externalTooltipHandler
        },
        datalabels: {
          color: 'transparent'
        },
        autocolors: false,
        annotation: {
          annotations: {
            line1: {
              type: 'line',
              borderColor: '#50514F',
              borderDash: [6, 6],
              borderDashOffset: 0,
              borderWidth: 3,
              scaleID: 'y',
              value: (ctx) => average(ctx)
            }
          }
        }
      },
      scales: {
        x: {
          grid: {
            display: false,
            drawBorder: false,
          },
          ticks: {
            color: '#50514F',
            font: {
              size: 18,
              weight: 500,
            },
          },
        },
        y: {
          grid: {
            drawBorder: false,
            display: false,
          },
          ticks: {
            beginAtZero: false,
            font: {
              size: 18,
              weight: 500,
            },
            /*  min: 99,
             max: 104, */
            stepSize: 1,
            // Include a dash sign in the ticks
            callback: function (value, index, ticks) {
              return value + " " + '-';
            },
          },
        },
      },
      maintainAspectRatio: false,
    }


    /* get all data graph data  */
    const pulpData = this.state.pulp_graph_data;
    function groupedBarData(bargraphData) {
      function getBarData(value) {
        let barData = bargraphData.map((e, i) => { if (e.hasOwnProperty(value)) return e[value]; else return null });
        return barData
      }
      const labels = bargraphData.map(item => item.id)

      const data = {
        labels,
        datasets: [
          {
            label: 'Massaved primavkalité',
            data: getBarData("Massaved Prima"),
            borderRadius: 50,
            borderSkipped: false,
            backgroundColor: '#2FAF9A',
            borderWidth: 2,
            borderRadius: 50,
            categoryPercentage: 0.5,
            barPercentage: 1.0
          },
          {
            label: 'Massaved sekundakvalité',
            data: getBarData("Massaved Sekunda"),
            borderSkipped: false,
            backgroundColor: '#6A58C6',
            borderRadius: 50,
            borderWidth: 2,
            borderRadius: 50,
            categoryPercentage: 0.5,
            barPercentage: 1.0
          },
          {
            label: 'Bränsleved',
            data: getBarData("Bränsleved"),
            borderSkipped: false,
            backgroundColor: '#F26157',
            borderRadius: 50,
            borderWidth: 2,
            borderRadius: 50,
            categoryPercentage: 0.5,
            barPercentage: 1.0
          },
        ],
      }
      const options = {
        responsive: true,
        plugins: {
          legend: {
            display: true,
            position: screen.width >= 1200 ? 'right' : 'bottom',
            align: screen.width >= 1200 ? 'center' : 'start',
            labels: {
              font: {
                size: screen.width >= 1200 ? '22' : '16',
                weight: 400,
                lineHeight: 50,
              }
            }
          },
          tooltip: {
            enabled: true
          },
          datalabels: {
            color: 'transparent'
          },

        },
        scales: {
          x: {
            grid: {
              display: false,
              drawBorder: false,
            },
            ticks: {
              font: {
                size: 18,
                weight: 500,
              },
              color: '#2A2E33',
            },
          },
          y: {
            grid: {
              display: false,
              drawBorder: false,
            },
            ticks: {
              font: {
                size: 18,
                weight: 500,
              },
              color: '#2A2E33',
              callback: function (value, index, ticks) {
                return value + " " + '-';
              },
              min: 0,
              max: 300,
              stepSize: 100,
              grace: "0.5%"
            },
          },
        },
        maintainAspectRatio: false,
      }
      return {
        data,
        options
      }
    }

    const graphErrors = [this.state.buyerError, this.state.priceError, this.state.distrubutionError, this.state.timberError, this.state.pulpError].filter(item => item !== "")

    return <div>
      {!this.state.loading && <ContainerRoot>
        {this.state.hasSearched === true && this.state.hasPremium === false ? <a href={Window.react_data.links.premium}>
          <div className='container-fluid bg-neutral-charcoal text-center p-2 fixed-top'>
            <p className='white caption my-2' >Vill du ta del av all data? <span style={{
              fontWeight: "900"
            }}>Skaffa Skogsövervakning</span> och få alla fördelar av Treebula.</p>
          </div>
        </a> : null}
        <div style={!this.state.hasSearched ? { background: "transparent" } : { background: "#FFFFFF" }}>
          <div className="container">
            {!(["Gran", "Tall"].includes(this.state.tree_lbl)) && this.state.buyer_count !== null ?
              <div className='pt-5'>
                <h4 className='neutral-charcoal mt-2 mt-md-0 n-fs-2'>Visar resultat för <span className="supp-pine">{this.state.tree_lbl} i {this.state.muni_lbl}</span></h4>
                <div className='col-12 col-md-10  py-4'>
                  <p className='neutral-charcoal'>
                    {this.state.hasPremium && this.state.pulp_graph_data.length == 0 || !this.hasTimberdata() ? <span>Det finns inga offentliga massavedsprislistor för trädslaget {this.state.tree_lbl} i {this.state.muni_lbl} kommun </span> : null}
                    I <span style={{ fontWeight: 700 }}>{this.state.buyer_count.name}</span> finns det <span style={{ fontWeight: 600 }}>{this.state.buyer_count.count} köpande bolag</span>. Nedan kan du se deras offentliga prislistor. Vill du ha anbud av alla dessa bolag? - <a className='fw-bold' href="/salj-virke/">Klicka här</a>
                  </p>
                </div>
              </div>
              : null}
            <div>
              {this.state.real_price_data && ["Gran", "Tall"].includes(this.state.tree_lbl) ? (
                <ComparisonRealPrice
                  heading={<h4 className="neutral-charcoal mt-0 n-fs-2">Virkespriser på genomförda affärer i <span className='supp-pine'>{this.state.muni_lbl}</span></h4>}
                  title={this.state.buyer_count !== null ? <h4 className='neutral-charcoal mt-5 pt-2  mt-md-0 n-fs-2'>Visar resultat för <span className="supp-pine">{this.state.tree_lbl} i {this.state.muni_lbl}</span></h4> : null}
                  description={this.state.buyer_count !== null ? <p className='neutral-charcoal'>
                    {this.state.hasPremium && this.state.pulp_graph_data.length == 0 || !this.hasTimberdata() ? <span className="neutral-charcoal">Det finns inga offentliga massavedsprislistor för trädslaget {this.state.tree_lbl} i {this.state.muni_lbl} kommun</span> : null}
                    I <span className="neutral-charcoal" style={{ fontWeight: 700 }}>{this.state.buyer_count.name}</span> finns det <span className="neutral-charcoal" style={{ fontWeight: 600 }}>{this.state.buyer_count.count} köpande bolag</span>. Nedan kan du se deras offentliga prislistor. Vill du ha anbud av alla dessa bolag? - <a className='fw-bold' href="/salj-virke/">Klicka här</a>
                  </p> : null}
                  has_premium={this.state.hasPremium ? true : false}
                  data={this.state.real_price_data}
                  tree_name={this.state.tree_lbl} />) : null}

            </div>
          </div>

          {/* LINKEDIN TRACKING WHEN SEARCH IS DONE */}
          {this.hasTimberdata() ?
            <img height="1" width="1" style={{ "display": "none" }} alt="" src="https://px.ads.linkedin.com/collect/?pid=4104234&conversionId=8499218&fmt=gif" />
            : null}

          <div className="">
            {this.hasTimberdata() ?
              <div className="py-3 position-relative" id="timber">
                <div className='container'>
                  <HourPricesGraphSection
                    title={<h4 className='neutral-charcoal n-fs-2'>Grundpriser på sågtimmer av gran i <span className="supp-pine">{this.state.tree_lbl} i {this.state.muni_lbl}</span></h4>}
                    description={!this.state.hasPremium ? <p className='neutral-charcoal'>För att se alla kvalitéer behöver du Skogsövervakning</p> : <div>
                      <p className='neutral-charcoal'>
                        Treebula strävar alltid efter att hålla priserna i prisjämförelsen uppdaterad men ibland kan prisförändringar ske snabbt. Vi förbehåller och därför eventuella fel och fördröjning vid uppdatering. Ser du ett fel? Tveka inte på att kontakta oss! <a href="mailto: info@treebula.se?subject=Fel%20i%20prisjämförelsen" className='fw-medium supp-pine text-decoration-underline'>info@treebula.se</a>.</p>
                      <div className="mt-4">
                        <a href="/auctions/" className='n-btn btn-outline btn-charcoal btn-sm text-wrap w-80'>Se virkesannonser</a>
                      </div>

                      <p className='d-flex flex-row py-3'>
                        {this.state.distributions_data.map(item =>
                          <p className="neutral-charcoal pe-4"><span>{item.label} </span> : <span>{item.value}%</span></p>
                        )}
                      </p>
                    </div>}
                    options={hourPricesOptions}
                    plugins={[hourPricesTooltipLine]}
                    dataProps={hourPriceAllDataProps}
                    prevIcon={Window.static_path + 'img/icons/LeftGraph.png'}
                    nextIcon={Window.static_path + 'img/icons/RightGraph.png'}
                  //prevHoverIcon={Window.static_path + 'img/icons/LeftHover.png'}
                  //nextHoverIcon={Window.static_path + 'img/icons/RightHover.png'}
                  />
                </div>
              </div> : null}
          </div>

          {this.state.pulp_graph_data.length > 0 || non_premium_member ?
            <div className="container position-relative mt-5">
              {!this.state.hasPremium ?
                <div className='' style={{ position: 'absolute', zIndex: 1, top: "1rem" }}>
                  <h3 className='neutral-charcoal n-md-h4'>Massavedspriser för <span className="supp-pine">{this.state.tree_lbl} i {this.state.muni_lbl} </span></h3>
                  <div className='col-12 col-lg-12 py-3'>
                    <p className='neutral-charcoal'> Nedan visas publika grundpriser exkl. premier och tillägg.</p>
                  </div>
                </div> : null}
              {!this.state.hasPremium ?
                   <TailwindWrapper>
                   <div className='absolute z-10 p-8 top-40 xl:w-2/4 rounded-2xl h-1/4 flex flex-col bg-[#2a2e33]'>
                     <Text variant='displayAndHeadline2XtraSmallMedium' className='text-white'>Vill du jämföra massavedspriser i din kommun?</Text>
                     <div className='mt-auto'>
                       <Button
                          tw
                         variant="secondary"
                         onClick={() => window.location.href = Window.react_data.links.premium}
                       >
                         Skaffa Treebula Plus
                         <Icon tw name="ArrowRightSimple" size="medium" />
                       </Button>
                     </div>
                   </div>
                 </TailwindWrapper> : null}

              <div id="pulp" className="py-5" style={this.state.hasPremium ? {
                background: "transparent",
              } : {
                background: "#F5F7F6",
                filter: "blur(7px)",
                position: "relative",
                top: 0,
                left: 0,
                height: "100%",
                width: "100%"
              }} >
                <div>
                  <BarGraphSection
                    title={this.state.hasPremium ? <h3 className='neutral-charcoal n-md-h4'>Massavedspriser för <span className="supp-pine">{this.state.tree_lbl} i {this.state.muni_lbl} </span></h3> : null}
                    description={this.state.hasPremium ? ' Nedan visas publika grundpriser exkl. premier och tillägg.' : null}
                    data={this.state.pulp_graph_data.length === 0 ? groupedBarData(dummybarData).data : groupedBarData(pulpData).data}
                    options={groupedBarData(pulpData).options}
                  />
                </div>
              </div></div> : null}
        </div>
       {premium_member ? <div id="premium" className="bg-green">
          {!this.state.hasPremium ?
            <GuldAnnons
              title="Uppgradera till skogsövervakning"
              description="När du skaffar Skogsövervakning kan du se all information som bolagsnamn, massavedspriser, antalet köpare i din kommun samt alla timmerkvalitéer och mycket mer."
              buttonLink="/min-skog/?view=overvakning"
              buttonText="Skaffa Skogsövervakning" /> :null
            // <GuldAnnons
            //   title="Sälj ditt virke till bästa pris – kostnadsfritt"
            //   description="Oavsett om du går i sälj tankar eller redan har fått en offert kan vi hjälpa dig att få bättre betalt - tryggt, kostnadsfritt och utan förbindelser. Fyll i formuläret nedan så hör en av våra rådgivare av sig med mer information."
            //   buttonLink={"https://virkesborsen.typeform.com/to/DPp5jv1e#email=xxxxx"}
            //   buttonText="Kontakta rådgivare" />
              }
        </div> : null}
      </ContainerRoot >}

      {graphErrors.length === 0 ? null : <Modal ref={this.errorGraphModal} show={this.state.errorGraphModal} onHide={() => this.setState({ errorGraphModal: false })} contentClassName="bg-red-alert p-2" centered>
        <Modal.Body>
          <h2 className="primary-main">OOPS! NÅGOT GICK FEL.</h2>
          <p className='white py-3'>{graphErrors.length === 1 ? `${graphErrors[0]}  graph data for ${this.state.tree_lbl}, ${this.state.muni_lbl} is currently not available` : <React.Fragment>The following data graphs are not available for {this.state.tree_lbl}, {this.state.muni_lbl}:
            <ul>
              {graphErrors.map((item) => <li>{item}</li>)}
            </ul></React.Fragment>}
          </p>
          <button type="button" className="btn btn-secondary btn-sm float-end" onClick={() => this.setState({ errorGraphModal: false })}>FORTSÄTT</button>
        </Modal.Body>
      </Modal>}
    </div>
  }

  contentSection() {
    const sections = [{ number: 1, title: "Fyll i fälten i formuläret" }, { number: 2, title: "Klicka på “Visa resultat" }, { number: 3, title: "Få en lista över aktuella virkespriser från olika köpare i din kommun" }]

    return <div className='bg-neutral-stone-100'>
      <div className='container'>
        <div className={`p-lg-5 p-4 col-12 d-flex flex-column flex-lg-row`}>

          {/* Main Header here */}
          <div className='col-lg-6 col-12 me-lg-3'>
            <h4 className={`n-fs-2 fw-medium`}>Så jämför du virkespriser</h4>
            <p className={`d-block`}>Det är snabbt, enkelt och hjälper dig att fatta välgrundade beslut inför din försäljning.</p>
          </div>

          {/* Section here */}
          <div className='col-lg-6 col-12'>

            {sections.map((section, index) => (
              <div key={index} className={`col-12 d-flex flex-row ${index > 0 ? 'mt-4' : ''}`}>
                <div className='col-2 col-md-1 vertical-align-middle pe-4 overflow-hidden'>
                  <p className={`n-fs-5 align-text-center primary-core bg-supp-forest-green d-flex justify-content-center rounded-3 px-3 py-1 mb-2 text-align-center`}>{section.number}</p>
                  {index < sections.length - 1 && (
                    <div className="d-flex ms-3" style={{ height: '90%', width: '6px'}}>
                      <div className={`vr supp-forest-green opacity-100 h-100`} style={{width:"2px", minHeight:"2em"}}></div>
                    </div>
                  )}
                </div>
                <div className='col-10 ms-md-2 ms-1'>
                  <h4 className={`n-fs-5 text-break`}>{section.title}</h4>
                </div>
              </div>
            ))}
          </div>

        </div>
      </div>
    </div>
  }

  reasonsSection(){
    const points = [{title:"Helt kostnadsfritt",paragraph:"Vår virkesprisjämförelse är kostnadsfri att använda."},
      {title:"Aktuella siffror",paragraph:"Vi använder de senaste marknadsdata för att ge dig korrekta prisuppgifter."},
      {title:"Snabbt & enkelt",paragraph:"Inga krångliga processer, få resultat på bara några sekunder."},
      {title:"Bättre förhandlingsstyrka",paragraph:"Med tydlig information står du bättre rustad i förhandlingar."}
    ]
    return<div className='py-5'>
      <div className='container'>
        <div className={`d-flex flex-column flex-md-row rounded-4 overflow-hidden bg-white`}>      
          {/* Image here */}
          <div className={`col-12 col-md-6`}>
            <img alt={"couple"} src={`${Window.static_path + 'img/other/couple.jpg'}`} className={'img-fluid w-100 h-100'}></img>
          </div>

          {/* Text here */}
          <div className={`d-flex align-items-start flex-column col-12 col-md-6 bg-neutral-charcoal py-5 px-4 px-md-5`}>
            <p className={`primary-core n-fs-2 mt-4 mb-3`}>Varför jämföra virkespriser hos Treebula?</p>
            <p className={`n-fs-6 mb-4 mb-md-5 white`}>Att sälja virke är en viktig affär, och rätt pris kan göra stor skillnad för din skogsekonomi. Treebulas prisjämförelse är utformad för att ge dig en tydlig och uppdaterad överblick över marknaden, så att du inte missar bättre erbjudanden.</p>

            {points.map((point) =>(<div className='mb-3'>
              <p className="white d-flex align-items-start"><img className="primary-core-filter me-4" src={Window.static_path + "img/icons/checkmark.svg"}alt="Checkmark"style={{ width: "24px", height: "24px" }}/><span><span className="d-block n-fs-6 fw-medium">{point.title}</span><span className="d-block n-fs-7">{point.paragraph}</span></span></p>
              </div>))}
            {/* Button here */}
            <div className="row row-cols-1 row-cols-md-auto g-3 justify-content-md-start mt-4 mt-md-3">
              <button className="n-btn btn-core me-md-3 col" onClick={() => { window.scrollTo({ top: 0, behavior: 'smooth' })}}>Jämför ditt pris</button>
              <button className="n-btn btn-outline btn-core primary-core col" onClick={() => { this.contactUs() }}>Kontakta rådgivare</button>
            </div>
            
          </div>
        </div>

      </div>

    </div>
  }

  handleToggle = (index) => {
    this.setState((prevState) => ({
        openItems: [...prevState.openItems].map((open, i) => (i === index ? !open : open)),
    }));
};
  faqSection(){
    const questions= [{question:"Kostar det något att jämföra virkespriser på Treebula?",answer:"Nej, prisjämförelsen är helt kostnadsfri. Det enda du behöver göra är att fylla i dina uppgifter i formuläret för att se resultatet."},
      {question:"Hur uppdaterade är priserna?",answer:"Treebula använder de senaste marknadsuppgifterna för att ge dig aktuella priser från köpare i din kommun."},
      {question:"Varför ska man jämföra virkespriser?",answer:"Genom att jämföra virkespriser får du en tydligare bild av vad ditt virke är värt och kan fatta mer informerade beslut vid försäljning."},
      {question:"Vilka faktorer avgör virkespriset?",answer:"Virkespriset påverkas av trädslag, kvalitet, mängd, köpare som finns i området och lokala marknadsförhållanden."}]
    return<div className='bg-neutral-stone-100'>
      <div className='container'>
        <div className='row py-5'>
          <div className='col-12 col-md-6 mb-4 mb-md-0'>
            <p className='n-fs-3 fw-medium mb-4'>Få svar på vanliga frågor, hjälp och vägledning när du jämför priser.</p>
            <button className='n-btn btn-charcoal' onClick={()=>{window.location.href = "/kontakta-oss/" }}>Kontakta oss <span><img className="ms-2 primary-core-filter" src={Window.static_path+"img/icons/arrow-black.svg"} style={{width: "18px", height: "18px"}}/></span></button>
          </div>
          <div className='col-12 col-md-6'>
            {questions.map((i, index, array) => {
              const isLastItem = index === array.length - 1;
              return <AccordionItem key={index} className={this.state.openItems[index] ? 'open' : ''} isLastItem={isLastItem}>
                <QuestionHeading onClick={() => this.handleToggle(index)}>
                  <PlusIcon isOpen={this.state.openItems[index]} />
                  <span className="n-fs-6">{i.question}</span>
                </QuestionHeading>
                {this.state.openItems[index] && <AccordionBody className="n-fs-6">{i.answer}</AccordionBody>}
              </AccordionItem>
            })}
          </div>
        </div>
      </div>
    </div>
  }
  
  moreServicesSection(){
    const services = [{icon: `${Window.static_path}img/icons/fat-tree.svg`,title:"Sälj Virke",paragraph:"Skapa annons och få anbud idag.",href:`/salj-virke/`},
      {icon: `${Window.static_path}img/icons/gas-station.svg`,title:"Biobränsle",paragraph:"Få prisförslag på ditt biobränsle.", href:`/biobransle/`},
      {icon: `${Window.static_path}img/icons/suitcase-star.svg`,title:"Digital skogsbruksplan",paragraph:"Kostnadsfri överblick över din skog",href:`/skogsbruksplan/`}]
    return <div className='container'>
      <div className='py-5'>
        <p className='fw-medium n-fs-4'>Fler tjänster hos Treebula</p>
        <div className='row mt-4'>
          {services.map((service) => <div className='col-12 col-md-4'>
            <div className='bg-neutral-stone-100 ms-2 ms-md-0 me-2 me-md-4 mt-3 mt-md-0 p-2 rounded-3 row' onClick={()=>{window.location.href = service.href}} style={{cursor:"pointer"}}>
              <div className='col-2'><img src={service.icon} alt='icon' style={{ width: "24px", height: "24px" }}/></div>
              <p className='col-8 col-md-9 align-items-start n-fs-7'><span><span className="d-block fw-medium">{service.title}</span><span className="d-none d-md-block">{service.paragraph}</span></span></p>
             <div className='col-2 col-md-1 text-end'> <img className='neutral-charcoal-filter' src={Window.static_path + "img/icons/caret.svg"} alt='caret' style={{ width: "16px", height: "16px" }}/></div>
            </div>
          </div>
          )}
       

      </div>
      </div> 
    </div>
  }
  
  contactUsSection() {
    return <div className='bg-neutral-charcoal'>
      <div className='container '>
        <div className='row py-5'>
          <div className='col-12 col-md-6'>
            <p className='white n-fs-3 fw-medium'>Nyfiken på vad du kan få för pris på ditt virke?</p>
            <p className='white n-fs-6'>Vi berättar gärna mer. Kontakta oss så bokar vi in en tid som passar dig.</p>
          </div>
          <div className='col-12 col-md-6 ps-md-5 mt-3 mt-md-0 position-relative '>
            <div className='d-flex align-items-start align-items-md-end flex-column position-relative'>
              <div className='d-flex align-items-center flex-column'>
                <button className='n-btn btn-core' onClick={() => { this.contactUs() }}>info@treebula.se</button>
                <p className='white fw-medium n-fs-5 text-md-center mt-3'>08-33 99 44</p>
              </div>
            </div>
          </div>
        </div>
        <Modal show={this.state.messageSentModal}
          onHide={() => { this.setState({ messageSentModal: false, mobile_phone_number: '' }) }}
          size="md" contentClassName="bg-white" centered>
          <Modal.Header className="align-items-start border-0" closeVariant="white" closeButton>
            <h2 className="supp-charcoal mb-0">Skickat</h2>
          </Modal.Header>
          <Modal.Body className="py-0">
            <p className="supp-charcoal mb-0">Ditt meddelande har skickats och vi kontaktar dig inom kort.</p>
          </Modal.Body>
          <Modal.Footer className="justify-content-end border-0">
            <button className="n-btn btn-forest-green btn-sm" onClick={() => this.setState({ messageSentModal: false})}>Stäng</button>
          </Modal.Footer>
        </Modal>
      </div>
    </div>
  }



  render() {
    return <div>
      <Navigation/>
      {this.headerSection()}
      {this.graphSection()}
      {this.contentSection()}
      {this.reasonsSection()}
      {this.faqSection()}
      {this.moreServicesSection()}
      {this.contactUsSection()}
      <Footer/>
    </div>
  }

}
export default PriceComparison;